import moment from 'moment';
import { themes } from '../theme/styles/themeJS';

export function rgb2hex(red, green, blue) {
    return (!!red & !!green & !!blue) ? '#' +
      ('0' + parseInt(red, 10).toString(16)).slice(-2) +
      ('0' + parseInt(green, 10).toString(16)).slice(-2) +
      ('0' + parseInt(blue, 10).toString(16)).slice(-2) : '';
  }

  /*	This function defines styles for elements while applying theme
      - currentComponent: The component in which we want to apply style
      - selectedTheme: The selected theme colour
      - elementList - The list of elements within the component, to which we want to apply style. It contains data in the
                      following format:
                      {"classNames":"widgetheader", "elementType":"normal", "applyTo":"single", "tagNames":"div"}
                      - classNames: The element's class name
                      - elementType: There are 2 possible values.
                                     It the element is a tab, pass 'tab' or if it is a table tr without a class, pass 'tr'
                      - applyTo: It can have the following values:
                                  - single: If there are multiple elements wih same class names in a single component,
                                              then value is single
                                  - alternate: To apply alternate colours to any element (could be table or div).
          -
  */
  export function applyStyle (currentComponent, selectedColorTheme, elementsList) {
      for(var i = 0; i<elementsList.length; i++){
          if(elementsList[i] !== undefined && elementsList[i].classNames !== undefined){
              var selectedElement = "";
              var selectedClassnames = elementsList[i].classNames;
              if(selectedClassnames !== "react-calendar__tile--active" && selectedClassnames !== "react-calendar__navigation__label" && selectedClassnames !== "react-calendar__month-view__weekdays__weekday" && selectedClassnames !== "react-calendar__navigation__arrow"){
                if(selectedClassnames.indexOf('_') != -1){
                    selectedClassnames = selectedClassnames.substring(0,selectedClassnames.indexOf('_'));
                }
              }else{
                selectedClassnames =  elementsList[i].classNames;
              }

              if(elementsList[i].elementType === "tag" && elementsList[i].applyTo === "single"){
                  selectedElement = currentComponent.getElementsByTagName(elementsList[i].tagNames);
                  selectedClassnames = "listRow";
                  var count = 0;
                  applyColorToEachSelectedElement(count, selectedElement, selectedColorTheme, selectedClassnames);
              }else if(elementsList[i].elementType === "tag" && elementsList[i].applyTo === "all" && elementsList[i].tagNames === "tspan"){
                  selectedElement = currentComponent.getElementsByTagName(elementsList[i].tagNames);
                  for(var s = 0; s<selectedElement.length; s++){
                      if(s%2 === 0){
                          selectedClassnames = "tspan";
                          applyColorToEachSelectedElement(s, selectedElement, selectedColorTheme, selectedClassnames);
                      }else{
                          selectedClassnames = "react-stockcharts-tooltip-label";
                          applyColorToEachSelectedElement(s, selectedElement, selectedColorTheme, selectedClassnames);
                      }
                  }
              }else if(elementsList[i].elementType === "tag" && elementsList[i].applyTo === "alternative"){
                  selectedElement = currentComponent.getElementsByTagName(elementsList[i].tagNames);
                  for(var k = 0; k<selectedElement.length; k++){
                      if(k%2 !==0){
                            var count = k;
                            selectedClassnames = "listRow";
                            applyColorToEachSelectedElement(count, selectedElement, selectedColorTheme, selectedClassnames);
                      }else{
                            var count = k;
                            selectedClassnames = "listRowNext";
                            applyColorToEachSelectedElement(count, selectedElement, selectedColorTheme, selectedClassnames);
                      }
                  }
              }else if(elementsList[i].elementType === "tabs" && elementsList[i].applyTo === "single" && elementsList[i].parent === "widgetheader" && elementsList[i].classNames !== ""){
                  selectedElement = currentComponent.getElementsByClassName(elementsList[i].classNames);
                  selectedClassnames = "tabMenu";
                  applyColorToEachSelectedElement(0, selectedElement, selectedColorTheme, selectedClassnames);
              }else if(elementsList[i].elementType === "tabs" && elementsList[i].applyTo === "single" && elementsList[i].parent === "widgetheader" && elementsList[i].classNames === ""){
                  selectedElement = currentComponent.getElementsByTagName(elementsList[i].tagNames);
                  selectedClassnames = "tabMenu";
                  applyColorToEachSelectedElement(0, selectedElement, selectedColorTheme, selectedClassnames);
              }else if(elementsList[i].elementType === "tabs" && elementsList[i].applyTo === "all" && elementsList[i].parent === "reportheader" && elementsList[i].classNames !== ""){
                  selectedElement = currentComponent.getElementsByClassName(elementsList[i].classNames);
                  selectedClassnames = "defaultTab2";
                  var count = selectedElement.length;
                  for(var k = 1; k<count; k++){
                      applyColorToEachSelectedElement(k, selectedElement, selectedColorTheme, selectedClassnames);
                  }
              }else if(elementsList[i].elementType === "tabs" && elementsList[i].applyTo === "all" && elementsList[i].parent === "widgetheader" && elementsList[i].classNames === ""){
                  selectedElement = currentComponent.getElementsByTagName(elementsList[i].tagNames);
                  selectedClassnames = "defaultTab";
                  var count = selectedElement.length;
                  for(var k = 1; k<count; k++){
                      applyColorToEachSelectedElement(k, selectedElement, selectedColorTheme, selectedClassnames);
                  }
              }else if(elementsList[i].elementType === "tabs" && elementsList[i].applyTo === "single" && elementsList[i].parent !== "widgetheader"  && elementsList[i].classNames !== ""){
                  selectedElement = currentComponent.getElementsByClassName(elementsList[i].classNames);
                  selectedClassnames = "tabMenu2";
                  applyColorToEachSelectedElement(0, selectedElement, selectedColorTheme, selectedClassnames);
              }else if(elementsList[i].elementType === "tabs" && elementsList[i].applyTo === "all" && elementsList[i].parent !== "widgetheader"  && elementsList[i].classNames !== ""){
                  selectedElement = currentComponent.getElementsByClassName(elementsList[i].classNames);
                  selectedClassnames = "defaultTab";
                  var count = selectedElement.length;
                  for(var k = 1; k<count; k++){
                      applyColorToEachSelectedElement(k, selectedElement, selectedColorTheme, selectedClassnames);
                  }
              }else if(elementsList[i].elementType === "normal" && elementsList[i].applyTo === "single"){
                  selectedElement = currentComponent.getElementsByClassName(elementsList[i].classNames);
                  applyColorToEachSelectedElement(0, selectedElement, selectedColorTheme, selectedClassnames);
              }else if(elementsList[i].elementType === "normal" && elementsList[i].applyTo === "alternative"){
                  selectedElement = currentComponent.getElementsByClassName(elementsList[i].classNames);
                  for(var k = 0; k<selectedElement.length; k++){
                      if(k%2 ===0){
                          var count = k;
                          applyColorToEachSelectedElement(count, selectedElement, selectedColorTheme, selectedClassnames);
                      }
                  }
              }else{
                  selectedElement = currentComponent.getElementsByClassName(elementsList[i].classNames);

                  if(selectedClassnames === "__react_component_tooltip"){
                  }
                  for(var k = 0; k<selectedElement.length; k++){
                      applyColorToEachSelectedElement(k, selectedElement, selectedColorTheme, selectedClassnames);
                  }
              }

          }else{
              break;
          }
      }
  }

  /*	This function applies css properties to the elements
      - elm: No of elements to apply css properties to
      - selectedElement: List of elements on which we will apply the css property.
                          We will apply it on the selected element from this list
      - selectedColorTheme: The selected theme colour
      - selectedClassnames: The selected element class name
  */
  function applyColorToEachSelectedElement(elm, selectedElement, selectedColorTheme, selectedClassnames){
      //console.log(selectedColorTheme);
      if(selectedClassnames !== undefined){
          if(selectedColorTheme[selectedClassnames] !== undefined){
              var styleObj = selectedColorTheme[selectedClassnames];
              for(var key in styleObj){
                  if(selectedElement[elm] !== undefined){
                      selectedElement[elm].style[key] = styleObj[key];
                  }else{
                      break;
                  }
              }
          }
          /*var styleObj = selectedColorTheme[selectedClassnames];
          for(var key in styleObj){
              if(selectedElement[elm] !== undefined){
                  selectedElement[elm].style[key] = styleObj[key];
              }else{
                  break;
              }
          }*/
      }

  }

  /*	This function is used to apply css styles to active tabs (only for Trade Activity Panel. Use later for Report as well)
      - elm: The elements on which the active tab css will be applied
      - selectedColorTheme: The selected theme's CSS
  */
  export function applyClickActive(elm, selectedColorTheme, parent){

    try{
        for(var i = 0; i<elm.length; i++){
            var styleObj = {};
            var classNames ="";
            //console.log(elm[i].getAttribute("class","active"));
            if(elm[i].getAttribute("class").indexOf("menuItem") === -1){
                if(elm[i].getAttribute("aria-selected") === "true" || elm[i].getAttribute("class") === "active"){
                    if(parent === "widgetheader" && classNames !== undefined){
                        classNames = "tabMenu";
                    }else{
                        classNames = "tabMenu2";
                    }
                    styleObj = selectedColorTheme[classNames];

                    clickActiveTabStyle(styleObj, elm[i]);
                }else{
                    if(parent === "widgetheader" && classNames !== undefined){
                        classNames = "defaultTab";
                    }else if(parent === "reportheader" && classNames !== undefined) {
                        classNames = "defaultTab2";
                    }else{
                      classNames = "defaultTab";
                    }
                    styleObj = selectedColorTheme[classNames];
                    clickActiveTabStyle(styleObj, elm[i]);
                }
            }else{
                classNames = "menuItem";
            }

            elm[i].addEventListener("click",function(){

                if(this.getAttribute("class").indexOf("menuItem") === -1){
                    // for(var x = 0; x<elm.length; x++){
                    //     elm[x].setAttribute("aria-selected","false");
                    // }
                    removeActiveFromRemaining(elm, selectedColorTheme, parent, 0);
                    if(parent === "widgetheader" && classNames !== undefined){
                        classNames = "tabMenu";
                    }else{
                        classNames = "tabMenu2";
                    }
                    styleObj = selectedColorTheme[classNames];
                    clickActiveTabStyle(styleObj, this);
                }else{
                    for(var i = 0; i<elm.length; i++){
                       elm[i].setAttribute("style","");
                    }
                    removeActiveFromRemaining(elm, selectedColorTheme, null, 0);
                    styleObj = selectedColorTheme["activeClass"];
                    clickActiveTabStyle(styleObj, this);
                }

            });
            elm[i].addEventListener("mouseenter",function(){
                if(this.getAttribute("aria-selected") !== "true"){
                    if(parent === "widgetheader" && classNames !== undefined){
                        classNames = "tabMenu";
                    }else{
                        classNames = "tabMenu2";
                    }
                    styleObj = selectedColorTheme[classNames];
                    clickActiveTabStyle(styleObj, this);
                }
            });
            elm[i].addEventListener("mouseleave",function(){
                removeActiveFromRemaining(elm, selectedColorTheme, parent, 0);
            });
        };
    }catch(error){
        console.log(error)
    }

  };

  function removeActiveFromRemaining(x, selectedColorTheme, parent, staringPoint){
    var classNamese = "";
    var styleObj = {};
    try{
        if(parent !== null){
            if(parent === "widgetheader" && classNamese !== undefined && classNamese !== ""){
                classNamese = "defaultTab";
            } else if(parent === "reportheader" && classNamese !== undefined && classNamese !== ""){
                classNamese = "defaultTab2";
            } else{
                classNamese = "defaultTab";
            }
            for(var j = 0; j<x.length; j++){
                if(x[j].getAttribute("class") !== "active" && x[j].getAttribute("aria-selected") === null){
                    classNamese = "defaultTab";
                    styleObj = selectedColorTheme[classNamese];
                    clickActiveTabStyle(styleObj, x[j]);
                } else if (x[j].getAttribute("class") !== "active" && x[j].getAttribute("aria-selected") === null && parent ==="reportheader" ) {
                  classNamese = "defaultTab2";
                  styleObj = selectedColorTheme[classNamese];
                  clickActiveTabStyle(styleObj, x[j]);
                } else if(x[j].getAttribute("class") !== "active" && x[j].getAttribute("aria-selected") !== "true" && parent ==="reportheader"){
                    classNamese = "defaultTab2";
                    styleObj = selectedColorTheme[classNamese];
                    clickActiveTabStyle(styleObj, x[j]);
                } else if(x[j].getAttribute("class") !== "active" && x[j].getAttribute("aria-selected") !== "true" && parent ==="widgetheader"){
                  classNamese = "defaultTab";
                  styleObj = selectedColorTheme[classNamese];
                  clickActiveTabStyle(styleObj, x[j]);
                }
            }
        }else{
            for(var j = 0; j<x.length; j++){
                classNamese = "menuItem";
                styleObj = selectedColorTheme[classNamese];
                clickActiveTabStyle(styleObj, x[j]);
            }
        }
    }catch(error){
        console.log(error);
    }

};



  export function applyToHover(component, elements, selectedColorTheme){
        //console.log(component);
       //console.log(elements);
      try{
        var classArr = [];
        for(var i = 0; i<elements.length; i++){
            var setClassName = elements[i].classNames;
            if(setClassName !== null){
                if(setClassName.indexOf('_') != -1){
                    setClassName = setClassName.substring(0,setClassName.indexOf('_'));
                    classArr.push(setClassName);
                }else{
                    if(setClassName !== "dateActive"){
                        classArr.push(setClassName);
                    }else{
                        classArr.push("react-calendar__tile--active");
                    }

                }
            }else{
                classArr.push("react-calendar__month-view__days__day");
                classArr.push("react-calendar__navigation__label");
                classArr.push("react-calendar__navigation__arrow");
            }
            if (elements[i].elmToHover !== undefined) {
              elements[i].elmToHover.addEventListener("mouseenter",function(){
                  var getClassName = this.getAttribute("class");
                  for(var j = 0; j<classArr.length; j++){
                      if(getClassName.search(classArr[j]) != -1){
                          var selectedClassnames = classArr[j] + "Hover";
                          var styleObject = selectedColorTheme[selectedClassnames];
                          clickActiveTabStyle(styleObject, this);
                      }
                  }
              });
              elements[i].elmToHover.addEventListener("mouseleave",function(){
                  var getClassName = this.getAttribute("class");
                  if(getClassName.indexOf("activeClass") === -1){
                      for(var j = 0; j<classArr.length; j++){
                          if(getClassName.search(classArr[j]) != -1){
                              var selectedClassnames = classArr[j];
                              var styleObject = selectedColorTheme[selectedClassnames];
                              clickActiveTabStyle(styleObject, this);
                          }
                      }
                  }
              })
            }
        }
      }catch(error){
        console.log(error);
      }
  }

  function clickActiveTabStyle(styleObject, element){
      try{
        for(var key in styleObject){
            element.style[key] = styleObject[key];
        }
      }catch(error){
        console.log(error);
      }
  };

export function getCountofTableRows(tableRows,tableColumns,value){
  let c=0;
   tableRows.map((item,index) => {
     for (var key in item) {
       let temp=item[key]===undefined||item[key]==="undefined" ? "" : item[key].toString().toUpperCase();
       if(temp.indexOf(value.toString().toUpperCase()) !== -1){
         var flag=0;
         for(let i=0;i<tableColumns.length;i++){
           if(key===tableColumns[i]){
             flag=1;
           }
         }
         if(flag===1){
           c++;
           break;
         }
       }
     }
   });
   return c;
}

//number formatter
// export function getSeparator(locale, separatorType) {
//         var numberWithGroupAndDecimalSeparator = 1000.1;
//         return Intl.NumberFormat(locale)
//             .formatToParts(numberWithGroupAndDecimalSeparator)
//             .find(part => part.type === separatorType)
//             .value;
// }

export function getSeparator(locale, separatorType) {
        var numberWithGroupAndDecimalSeparator = 1000.1;
        var num = new Intl.NumberFormat(locale).format(numberWithGroupAndDecimalSeparator);
         // console.log("num "+num);
        var value;
         if(separatorType === "group"){
            if (!isNaN(num.charAt(1)) && locale.includes('es')) {
            value = '';
            }else {
             value = num.charAt(1);
            }
           // console.log("valuegrp::"+value);
           return value
         }
        if(separatorType === "decimal"){
          if (!isNaN(num.charAt(1)) && locale.includes('es')) {
            value = num.charAt(4);
          }
          else {
            value = num.charAt(5);
          }
        // console.log("valueDecimal::"+value);
          return value
        }

        // var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        //   console.log("isSafari :"+isSafari);
}

export function setDirection(currentComponent, elementsList, selectedLang) {
  //console.log("you are in thme function");
  for(var i = 0; i<elementsList.length; i++){
      if(elementsList[i] !== undefined && elementsList[i].classNames !== undefined){
          var selectedElement = "";
          var selectedClassnames = elementsList[i].classNames;
          selectedElement = currentComponent.getElementsByClassName(elementsList[i].classNames);
          for(var k = 0; k<selectedElement.length; k++){
              applyDirection(k, selectedElement, selectedLang, selectedClassnames);
          }
      }else{
          break;
      }
  }
}
 //apply direction function

 export function applyDirection(elm,selectedElement, selectedLang, selectedClassnames) {
   if(selectedClassnames !== undefined){
     if (selectedLang[selectedClassnames] !== undefined) {
       var styleObj = selectedLang[selectedClassnames];
       for(var key in styleObj){
         if(selectedElement[elm] !== undefined){
             selectedElement[elm].style[key] = styleObj[key];
         }else{
             break;
         }
       }
     }
   }
  }

  export function unformatLang (item){
    var numberWithGroupAndDecimalSeparator = 1000.1;
    var num = new Intl.NumberFormat(navigator.language).format(numberWithGroupAndDecimalSeparator);
    let decimal = !isNaN(num.charAt(1))&& navigator.language.includes("es")   ? num.charAt(4) : num.charAt(5);
    let separator = !isNaN(num.charAt(1)) && navigator.language.includes("es") ? '' : num.charAt(1);
    // let decimal =num.charAt(5);
    // let separator = num.charAt(1);
    let spacesRegex = /\s+/
    if (item) {
      let itemString = item.toString()
      if (separator != ' ' || decimal != ' ' || !(spacesRegex.test(separator) || spacesRegex.test(decimal))) {
        itemString = itemString.replace(/\s+/g, '')
      }
      itemString = itemString.split(separator).join('')
      return (itemString).replace(decimal, '.');
    } else {
      return ""
    }
}

export function isOneYearRangeSelected(id, startDate, endDate) {
    if (id === "custom" || id === "prevYearDate" ) {
      let oneYearRange = new Date(startDate);
      oneYearRange = oneYearRange.setFullYear(oneYearRange.getFullYear() + 1);
      oneYearRange = getFormattedDate(oneYearRange);
      return endDate <= oneYearRange;
    }
  }
  
export function getFormattedDate(date) {
    return moment(date).format('YYYY/MM/DD');
}

export function setCurrentDate(startDateFY, firstDay, lastDay) {
    const calculateFirstDay = moment(startDateFY).isAfter(firstDay) ? startDateFY : firstDay;
      return getFormattedDate(calculateFirstDay) + ' - ' + getFormattedDate(lastDay);
}

export function getSelectedDate(type,date){
    let today = new Date();
    let currentDate = new Date();
    let startDateFY  = date && date.length ? new Date(date) : date // FY start date 
    let prevYrDate = date && date.length ? date.split('-') : date // prevYR Date
    let prevYrEndDate = date ? new Date(prevYrDate[1]) : date
    switch(type){
        case 'today':
            currentDate = getFormattedDate(today);
            break;
        case 'yest':
            let yest = moment(today).subtract(1, 'days');
            if (moment(startDateFY).isAfter(yest)) {
              currentDate = getFormattedDate(startDateFY);
            } else {
              currentDate = getFormattedDate(yest);
            }
            break;
        case 'last7Days':
            let sDate = moment(today).subtract(6, 'days');
            currentDate = setCurrentDate(startDateFY, sDate, today);
            break;
        case 'last30Days':
            let startDate = moment(today).subtract(29, 'days');
            currentDate = setCurrentDate(startDateFY, startDate, today);
            break;
        case 'last90Days':
            let firstDay = moment(today).subtract(89, 'days');
            currentDate = setCurrentDate(startDateFY, firstDay, today);
            break;
        case 'last3Months':
            let firstDayOfMnth = moment(today).subtract(3, "months");
            currentDate = setCurrentDate(startDateFY, firstDayOfMnth, today);
            break;
        case 'last6Months':
            let fstDayOfMnth = moment(today).subtract(6, "months");
            currentDate = setCurrentDate(startDateFY, fstDayOfMnth, today);
            break;
        case 'last1Year':
            let firstMonthDate = moment(today).subtract(1, "year");
            currentDate = setCurrentDate(startDateFY, firstMonthDate, today);
            break;
        case 'custom':
            currentDate = getFormattedDate(startDateFY) + ' - ' + getFormattedDate(today);
              break; 
        case 'prevYearDate':
          let prevYrSOfMnth = new Date(prevYrEndDate.getFullYear(), prevYrEndDate.getMonth(), 1); // last month date of prevYrEndDate 
          let prevYrEOfMnth = new Date(prevYrEndDate.getFullYear(), prevYrEndDate.getMonth() + 1, 0);
          currentDate = getFormattedDate(prevYrSOfMnth) + ' - ' + getFormattedDate(prevYrEOfMnth);
          break;          
        default:
            currentDate = getFormattedDate(today);
            break;
    }
    return currentDate;
}

/**
 * Takes RGB color and calculates lightness
 * @param {string} r 
 * @param {string} g 
 * @param {string} b 
 * @returns lightness %
 */
const getLightnessFromRGB = (r, g, b) => {
    // Divide by 255 to get values in range 0 and 1.
    r /= 255
    g /= 255
    b /= 255

    // Find greatest and smallest channel values
    const cmin = Math.min(r,g,b), cmax = Math.max(r,g,b)

    // Calculate lightness percent
    const lightness = (cmin + cmax) / 2
    return Math.floor(lightness * 100)
}

/**
 * Takes image URL and calculates images brightness
 * @param {string} imageSrc 
 * @param {function} callback 
 */
const getImageBrightness = (imageSrc, callback) => {
  // Get image URL and temporarily append to body
  const img = document.createElement("img");
  img.src = imageSrc;
  img.style.display = "none";
  img.crossOrigin = "anonymous";
  document.body.appendChild(img);

  img.onload = function () {
    /* 
        Create a canvas of size same as image
        Draw image on canvas
    */
    const canvas = document.createElement("canvas");
    canvas.width = this.width;
    canvas.height = this.height;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(this, 0, 0);

    // Get pixel data of images into array format
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const data = imageData.data;

    /* 
        Get all red, green and blue pixel values
        Find average of all red, green and blue pixels
      */
    let redValues = 0, greenValues = 0, blueValues = 0;
    for (let x = 0, len = data.length; x < len; x += 4) {
      redValues += data[x];
      greenValues += data[x + 1];
      blueValues += data[x + 2];
    }
    const totalPixels = data.length / 4;
    redValues /= totalPixels;
    greenValues /= totalPixels;
    blueValues /= totalPixels;

    // Get lightness value from the average color of the image
    const lightness = getLightnessFromRGB(redValues, greenValues, blueValues);
    callback(lightness);
  };

  // Remove image from the body
  document.body.removeChild(img);
};

/**
 * Sets the text color that is easy to read against the background image.
 * @param {string} textID 
 * @param {string} backgroundImageID 
 * @param {string} darkClass 
 * @param {string} lightClass 
 */
export const setContrastTextColor = (textID, backgroundImageID, darkClass, lightClass) => {
  // to get the text element and background image element
  const forgotPasswordLink = document.getElementById(textID);
  const imageElement = document.getElementById(backgroundImageID);

  if (imageElement) {
    // Get styles from the image element which has backgroundImage property
    const style = imageElement?.currentStyle ||window.getComputedStyle(imageElement, false);

    /* 
        backgroundImage has url("http://localhost:3002/images/bg.jpg") as value
        We require this link to be provide to extract colors
        below line removes url part and double quotes from the string
        output is - 'http://localhost:3002/images/bg.jpg' 
    */
    const backgroundImage = style.backgroundImage.slice(4, -1).replace(/"/g, "");

    // set light or dark class based on image brightness
    getImageBrightness(backgroundImage, function (brightness) {
      /* Remove dark and light classes from the element */
      forgotPasswordLink?.classList.remove(darkClass, lightClass);

      /* checks brightness of the image applies approriate dark or light classes */
      if (brightness > 50) {
        forgotPasswordLink?.classList.toggle(darkClass);
      } else {
        forgotPasswordLink?.classList.toggle(lightClass);
      }
    });
  }
}

/**
 * Takes location and theme 
 * provides dark or normal logo URL based on theme
 * provides normal logo URL if dark logo is unavailable
 * @param {string} location company code
 * @param {string} theme current applied theme 
 * @param {string} variant variant of logo
 * @param {object} event object of onerror event
 * @returns {string} logo URL - dark or normal
 */
export function setThemedLogo (location, theme, env, variant = 'dark', e = null) {
    try {
        const logo = `https://neox-asset.neofinancials.com/ntp/${env}/${location}/logo.png`
        const darkLogo = `https://neox-asset.neofinancials.com/ntp/${env}/${location}/logo_${variant}.png`

        if (e) {
            // directly sets logo on image tag
            return e.target.src = logo
        }
        return themes[theme]?.isDarkTheme ? darkLogo : logo
    } catch (e) {
        console.log({ setThemedLogoError: e})
    }
}

export function getDefaultAcdAccount(acd) {
  const defaultAccount = Array.from(acd.values()).filter(
    (values) => Number(values.DFA) === 1
  );
  return defaultAccount[0];
}

export function getAccountByCode(acd, accCode) {
    const account = Array.from(acd.values()).find((acc) => acc.C === accCode)
    return account
}

export function getInactiveAccounts(orderSelection, acd) {
    const inactiveAccounts = orderSelection
    .map(item => acd.get(item.accCode))
    .filter(account => account && account.isActiveAcc === "0");

  const uniqueInactiveAccounts = Array.from(new Set(inactiveAccounts));  
  return uniqueInactiveAccounts;
};


export function cleanUnitText(value) {
  if (!value) return '';
  return value.replace(/[()]/g, '').trim();
}

export function toEpoch(val) {
  if (!val) return 0;
  const [dateTime, tz] = val.split(" (UTC ");
  const offset = tz ? tz.replace(")", "") : "+0";
  // Parse with offset
  const epoch = moment(dateTime, "DD-MMM-YYYY hh:mm A")
    .utcOffset(offset)
    .valueOf();
  return epoch;
}

/**
 * Transforms given localized number to pure number 
 * with just decimal separator which is dot
 * this function acts as replacement for unformatLang
 * @param {string} intlNumStr localized number
 * @param {boolean} toParse whether to parse a number to float
 * @returns {number} language-agnostic number without number separator
 */
export function getPureNumber(inputNumber, toParse = true) {
  inputNumber = (inputNumber).toString();

  const userLanguage = navigator.language || navigator.userLanguage;
  const numberFormat = new Intl.NumberFormat(userLanguage);
  const numberToFormat = numberFormat.formatToParts(10000.1);
  const decimalSeparator = numberToFormat.find(part => part.type === 'decimal').value;
  let numberSeparator = numberToFormat.find(part => part.type === 'group').value;

  // Spaces have different unicodes so regex helps in matching all kinds of spaces
  if (/\s/.test(numberSeparator[0])) numberSeparator = '\s';

  let pureNumber;
  // Replace number separator globally; 15.667,900 -> 15667,900
  pureNumber = inputNumber.replace(new RegExp(`\\${numberSeparator}`, 'g'), '');
  // Replace decimal separator globally; 15667,900 -> 15667.900
  pureNumber = pureNumber.replace(new RegExp(`\\${decimalSeparator}`, 'g'), '.');

  // Handle cases where pureNumber is empty after replacements
  if (!pureNumber || pureNumber === '.') {
      return toParse ? 0 : '0';
  }
  return toParse ? parseFloat(pureNumber) : pureNumber;
}

export const getMinMaxFractionDigits = (format) => {
  const decimalSeparator = '.';
  const formatParts = format?.split(decimalSeparator)[1];
  const minFractionDigits = formatParts?.indexOf('#') !== -1 ? formatParts?.indexOf('#') : (formatParts?.length || 0);
  const maxFractionDigits = formatParts?.length ?? 0;
  return {
    minimumFractionDigits: minFractionDigits,
    maximumFractionDigits: maxFractionDigits,
  };
};

export function getFormattedRate (price, minDec, maxDec = minDec, usePureNumber = true, roundOffDigit = null) {
    let rate = usePureNumber ? getPureNumber(price, false) : price.toString();
    if(!rate.match(/^(0|[1-9]\d*)(\.\d+)?$/)){
        return "";
    }
    rate = usePureNumber ? getPureNumber(price) : price;
    let num = parseFloat(rate);
    if (roundOffDigit !== null && !isNaN(num)) {
        // Round to the specified number of decimal places
        const factor = Math.pow(10, roundOffDigit);
        num = Math.round(num * factor) / factor;
    }
    console.log({ num })
    const formattedRate = Number(num).toLocaleString(navigator.language, { minimumFractionDigits: minDec, maximumFractionDigits: maxDec, roundingMode: "trunc"});
    return (NaN).toLocaleString(navigator.language) === formattedRate ? "" : formattedRate;
}

export const convertEpochToEventTime = (epoch) => {
  return moment(epoch).format("YYYY-MM-DD HH:mm:ss.SSS");
}
